// AUTO-GENERATED by scripts/generate-metric-keys.js
// Do NOT edit manually. Run the script to regenerate.
// Source: post-for-me SDK v2.7.0
// Generated: 2026-05-15T08:12:28.637Z

/** Normalised metric keys we read from platform-specific payloads.
 *  Each platform uses different field names; we probe in order.
 *  This mapping is derived automatically from the post-for-me SDK type definitions. */
export const METRIC_KEYS = {
  likes: [
    "likes",
    "likeCount",
    "like_count",
    "digg_count",
    "reactions_like",
    "reactions_total",
    "reactions_love",
    "reactions_haha",
    "reactions_wow",
    "reactions_sorry",
    "reactions_anger",
    "reaction",
    "favorite_count",
  ] as const,
  comments: [
    "comments",
    "commentCount",
    "comment_count",
    "comment",
    "replies",
    "reply_count",
    "replyCount",
  ] as const,
  shares: [
    "shares",
    "shareCount",
    "share_count",
    "retweet_count",
    "reposts",
    "repostCount",
    "repost_count",
    "quotes",
    "quote_count",
    "quoteCount",
  ] as const,
  views: [
    "views",
    "viewCount",
    "view_count",
    "playCount",
    "play_count",
    "video_views",
    "impressions",
    "impressionCount",
    "impression_count",
    "impression",
    "reach",
    "media_views",
    "profile_views",
    "profile_visits",
    "viewer",
    "video_views_unique",
    "video_views_organic",
    "video_views_paid",
    "video_views_autoplayed",
    "video_views_clicked_to_play",
    "video_views_sound_on",
    "viral_reach",
    "organic_reach",
    "paid_reach",
    "fan_reach",
    "nonviral_reach",
    "video_views_organic_unique",
    "video_views_paid_unique",
    "video_views_15s",
    "video_views_60s",
  ] as const,
  saves: [
    "saves",
    "saveCount",
    "save_count",
    "saved",
    "save",
    "favorites",
    "bookmark_count",
  ] as const,
  clicks: [
    "clicks",
    "click_count",
    "link_clicks",
    "website_clicks",
    "url_link_clicks",
    "outbound_click",
    "pin_click",
    "address_clicks",
    "app_download_clicks",
    "email_clicks",
    "phone_number_clicks",
    "user_profile_clicks",
    "profile_activity",
    "navigation",
  ] as const,
} as const;

export type MetricCategory = keyof typeof METRIC_KEYS;

/** Read a numeric metric from a raw platform payload by probing candidate keys.
 *  Searches recursively through nested objects to handle platforms like
 *  Twitter (public_metrics / organic_metrics) and Pinterest (lifetime_metrics). */
export function readMetric(raw: unknown, keys: readonly string[]): number | null {
  if (raw == null) return null;

  // Direct match on current object
  if (typeof raw === "object" && !Array.isArray(raw)) {
    const obj = raw as Record<string, unknown>;
    for (const k of keys) {
      const v = obj[k];
      if (typeof v === "number") return v;
    }
    // Recurse into nested objects (but not arrays — avoid matching breakdown items)
    for (const v of Object.values(obj)) {
      if (v != null && typeof v === "object" && !Array.isArray(v)) {
        const found = readMetric(v, keys);
        if (found !== null) return found;
      }
    }
  }

  return null;
}

/** Extract the 6 core metrics from a raw platform payload. */
export function extractMetrics(raw: unknown): {
  likes: number | null;
  comments: number | null;
  shares: number | null;
  views: number | null;
  saves: number | null;
  clicks: number | null;
} {
  return {
    likes: readMetric(raw, METRIC_KEYS.likes),
    comments: readMetric(raw, METRIC_KEYS.comments),
    shares: readMetric(raw, METRIC_KEYS.shares),
    views: readMetric(raw, METRIC_KEYS.views),
    saves: readMetric(raw, METRIC_KEYS.saves),
    clicks: readMetric(raw, METRIC_KEYS.clicks),
  };
}
